import React from 'react';
import { motion } from 'framer-motion';

function Slide({ 
  title, 
  text, 
  buttonText, 
  buttonAction, 
  slideClass, 
  slideContentClass, 
  slideTitleClass, 
  slideTextClass 
}) {
  return (
    <motion.section 
      className={slideClass}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className={slideContentClass}>
        <div>
          <h1 className={slideTitleClass}>{title}</h1>
          <p className={slideTextClass}>{text}</p>
          {buttonText && (
            <button onClick={buttonAction}>
              {buttonText}
            </button>
          )}
        </div>
      </div>
    </motion.section>
  );
}

export default Slide;